import * as yup from 'yup';

import {
  INTERACTION_CREATED,
  INTERACTION_STATES,
} from 'constants-interactions';
import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  status: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: INTERACTION_STATES,
      },
    ],
  },
  data: {
    type: 'JSON',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  features: {
    type: 'JSON',
  },
  contentData: {
    type: 'JSON',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class UserContentInteractionType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'UserContentInteraction';

  friendlyName = 'Interaction';

  contexts = [TypeContextEnum.Data, TypeContextEnum.Properties];

  superUserOnly = false;
  properties = properties;

  get example() {
    return {
      _id: '000000Be3RPQB9nF9WZlwQ',
      userId: '4GC1pwkPNtGSeqkyzn3sAb',
      contentId: '4q9ZCVPZ0tPfgbkhUybgYJ',
      status: INTERACTION_CREATED,
      data: {},
      contentData: {},
    };
  }

  get default(): any {
    return null;
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const userContentInteractionTypeDefinition = new UserContentInteractionType();

Types.addBaseType(userContentInteractionTypeDefinition);
export { userContentInteractionTypeDefinition };
